import { Routes } from '@angular/router';

import { MainComponent } from './components/main/main.component';
import { roleRestrictionGuard } from './utilities/guards/role-restriction-guard';

export const routes: Routes = [
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  {
    path: '',
    component: MainComponent,
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./components/dashboard/dashboard.component').then((c) => c.DashboardComponent)
      },
      {
        path: 'agent-training',
        loadComponent: () => import('./components/training/training.component').then((c) => c.TrainingComponent),
        canActivate: [roleRestrictionGuard],
        data: {
          roleRestriction: ['training.write', 'training.read']
        }
      },
      {
        path: 'analytics',
        loadComponent: () => import('./components/analytics/analytics').then((c) => c.Analytics)
      },
    ]
}
];
